import React, { useState, useEffect } from "react"
import Loadable from "@loadable/component"
import Header from "./Header"
import Bread from "./Breadcrumbs"
import NavBar from "./navbar"
import Footer from "./footer"
import Theme from "@airasia/phoenix-components/components/Theme"
import {data as uhfData} from "../testData/uhfHeader";
import EmojiScoringWidget from "./EmojiScorings"
import QRPopUp from '@airasia/phoenix-widgets/widgets/QRPopUp';
import {
  AppCtaDesktopWrapper,
  AppCtaMobileWrapper,
  AppCtaWrapper,
} from "./mobileAppCta/staticDataWrapper"
import Styled from "styled-components"
import "../Css/main.css"
import icon from "../images/favicon.ico"
import iconaa from "../images/favicon-aa.ico"
import { Helmet } from "react-helmet"
// import * as Fn from "../functions"
import { GTM_PROJECT_CATEGORY, STATIC_FILE_PATH } from "../utils/constant"
import { fireGtmEvent, getGtmUserType, getUrlWithLanguage, getStickyBannerImageByLang } from "../utils/function"
import { WebVitalRUM } from "@airasia/phoenix-components/components"
import _ from "lodash"
import axios from "axios"
import Countdown from "react-countdown"
import { OpenInNew as OpenInNewIcon } from "@material-ui/icons"
import { Link } from "gatsby"
import CountDownText from "./CountDownText"
import { Typography } from "@material-ui/core"
import countDownTextsObj from "../utils/countdownTexts"
import StickyBanner from "./StickyBanner"
import CampaignBanner from "./CampaignBanner"
import { isBefore } from "date-fns"


const AVAChatbot = Loadable(() =>
  import("@airasia/phoenix-widgets/widgets/AVAChatbot")
)

var Container = Styled.div`
margin: 0 5%;
`

const CountDownContainer = Styled.div`
position: fixed;
cursor: pointer;
bottom: 0;
z-index: 11;
display: flex;
width: 100%;
color: white;
background: rgb(220, 50, 36);
background: url(https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/ripple-bg.png);
min-height: 60px;
max-height: 140px;
height: auto;
// display: flex;
justify-content: center;
align-items: center;
font-weight: bold;
font-size: 16px;
letter-spacing: 1.5px;
// font-family: monospace;
padding: 8px;
box-sizing: border-box;
text-align: center;
flex-direction: column;
gap: 8px;
& .countdownIcon{
  // display: none;
  font-size: 18px;
}
@media only screen and (min-width: 976px) {
  flex-direction:row;
  & .countdownIcon{
    display: inline-flex;
  }
}
@media only screen and (min-width: 1260px) {
  font-size: 24px;
}
& .inverseColorText{
  color: rgb(220, 50, 36);
  background: white;
  padding-inline: 4px;
}
`;

const MobileAvaContainer = Styled.div`
   @media only screen and (min-width: 768px) {
    display: none;
   }
`

const AvaContainer = Styled.div`
   @media only screen and (max-width: 768px) {
    display: none;
   }
`

export const DynamicWidth = SetWidth => {
  // console.log("running dynamic width",window.innerWidth );
  if (typeof window === "undefined") return
  const handleResize = () => {
    var width = window.innerWidth
    var SetArr = []
    if (width >= 990) {
      SetArr = "desktop"
    } else if (width >= 768) {
      SetArr = "tablet"
    } else {
      SetArr = "mobile"
    }
    SetWidth(PreArr => (PreArr != SetArr ? SetArr : PreArr))
  }
  handleResize()
  window.addEventListener("resize", handleResize)
  return () => {
    window.removeEventListener("resize", handleResize)
  }
}

export default function Layout(props) {

  // console.log("props ---- ", _.cloneDeep(props))
  const [Devices, setDevices] = useState("desktop")
  const [recentSearches, setRecentSearches] = useState([])

  var Format = (data, index) => {
    return {
      "@type": "ListItem",
      position: index + 1,
      name: data.title,
      item: data.href,
    }
  }

  function convertURL(url) {
    if (url != "" || url != null) var result = url.split("/")
    return result[result.length - 1]
  }
  function getLang(url) {
    if (url != "" || url != null) var result = url.split("/")
    if (result.length > 2) return result[1] ? result[1] : "en"
    else return "en"
  }

  // Get locale to generate the static CTA mobile app block
  function getLocale(url) {
    if (url !== "" || url != null || url != undefined) {
      // split on "/"
      // eg: /id/id/kuala-lumpur -> ["", "id", "id", "kuala-lumpur"]
      var locale = url.split("/")

      if (locale.length > 2) {
        // remove the last element
        // eg: ["", "id", "id", "kuala-lumpur"] -> ["", "id", "id"]
        locale.splice(locale.length - 1, 1)
        return locale.join("/")
      } else {
        return "/"
      }
    }

    return null
  }

  var baseURL = convertURL(props.url)
  var lang = getLang(props.url)
  const locale = getLocale(props.url)

  var BreadList = props.breadCrumbs.length
    ? [
        ...props.breadCrumbs.map((x, index) => Format(x, index)),
        Format({ title: props.routes }, props.breadCrumbs.length),
      ]
    : []
  const [innerWidth, setInnerWidth] = useState()
  // console.log("innerWidth",innerWidth)
  const onWindowResize = () => {
    if (typeof window !== undefined) {
      setInnerWidth(window.innerWidth)
    }
  }

  const avaGtmFire = () => {
    const obj = {
      event: "trackEventNoEcommerce",
      "eventDetails.category": `AVA Chat Bot`,
      "eventDetails.action": `click`,
      "eventDetails.label": `${GTM_PROJECT_CATEGORY} | ${getGtmUserType()}`,
    }

    if (typeof window !== "undefined") {
      window.gtmDataLayer = window.gtmDataLayer || []
      window.gtmDataLayer.push(obj)
    }
  }

  useEffect(() => {
    onWindowResize()
    window.addEventListener("resize", onWindowResize)
    return () => window.removeEventListener("resize", onWindowResize)
  }, [])

  useEffect(() => {
    DynamicWidth(setDevices)

    const recentSearchesCookie = JSON.parse(
      decodeURIComponent(localStorage.getItem("recentSearches"))
    )

    setRecentSearches(recentSearchesCookie)

    if (recentSearchesCookie === null || recentSearchesCookie.length === 0) {
      return
    }
  }, [])

  // const titleText = _.replace(_.get(_.find(_.get(props, "meta", []), x => _.isEqual(_.get(x, "property"), "og:title")), "content", ""), "{{current_year}}", new Date().toLocaleDateString(lang).split('/')[2]);
  // const descText = _.get(_.find(_.get(props, "meta", []), x => _.isEqual(_.get(x, "property"), "og:description")), "content", "");
  let stickyTexts = {
    "en-gb": "Book Your Flights Now and Save 20% all seats, all flights! Discover more",
    "ms-my": "Book Your Flights Now and Save 20% all seats, all flights! Discover more",
    "th-th": "จองตั๋วเครื่องบินวันนี้ รับส่วนลด 20% ทุกที่นั่ง ทุกเส้นทางบิน อ่านรายละเอียดเพิ่มเติม",
    "id-id": "Pesan Tiket Pesawat Anda Sekarang dan Hemat 20% Semua Kursi, Semua Penerbangan! Info Lebih Lanjut",
    "zh-cn": "立即预订您的机票，全部航班、全部座位享受20%的折扣！发现更多。",
    "zh-tw": "立即預訂您的機票，全部航班、全部座位享受20%的折扣！發現更多。",
    "zh-hk": "立即預訂您的機票，全部航班、全部座位享受20%的折扣！發現更多。",
    "ru-ru": "Бронируйте свои авиабилеты сейчас и экономьте 20% на все места, на все рейсы! Узнайте больше.",
    "tr-tr": "Şimdi Uçak Biletinizi Alın ve Tüm Koltuklarda, Tüm Uçuşlarda %20 İndirimden Faydalanın! Daha Fazlasını Keşfedin.",
    "ph-ph": "Mag-book ng inyong mga flights ngayon at makatipid ng 20% sa lahat ng upuan, lahat ng flights! Alamin pa",
    "vi-vn": "Đặt vé máy bay ngay bây giờ và tiết kiệm 20% cho tất cả các ghế, tất cả các chuyến bay! Khám phá thêm.",
    "ja-jp": "今だけ、全便全席 20% OFF！スーパーお得な航空券を見つけて、旅に出かけよう！",
    "ko-kr": "20% 할인! 모든 좌석, 모든 노선! 특별 행사! 더 많은 정보를 알아보세요.",
    "km-kh": "កក់កម្មវិធីប្រើប្រាស់របស់អ្នកឥតគិតថ្លៃឥតគិតថ្លៃ 20% ទីតាំងទាំងអស់ ទីតាំងទាំងអស់! រកឃើញបន្ថែម"
  }

  const [countdownTitle="", countdownSubtitle=""] = _.includes(props.url, 'campaign') ? [stickyTexts[props.lang] || "", ""] : [];
  const isCountdown = true;
  const countDownTexts = countDownTextsObj[props.lang] || countDownTextsObj['en-gb'];
  const bannerText = stickyTexts[props.lang] || stickyTexts['en-gb'];

  let titleText = !_.isEmpty(_.get(props, 'overrides.title')) ? _.get(props, 'overrides.title') :  _.replace(_.get(_.find(_.get(props, "meta", []), x => _.isEqual(_.get(x, "property"), "og:title")), "content", ""), "{{current_year}}", new Date().toLocaleDateString(props.lang).split('/')[2]);
  titleText = titleText.replaceAll('{{current_year}}', new Date().toLocaleDateString(props.lang).split('/')[2]).replaceAll(/20\d[0-5]/gi, new Date().toLocaleDateString(props.lang).split('/')[2]);
  let descText = !_.isEmpty(_.get(props, 'overrides.description')) ? _.get(props, 'overrides.description') : _.get(_.find(_.get(props, "meta", []), x => _.isEqual(_.get(x, "property"), "og:description")), "content", "");
  descText = descText.replaceAll('{{current_year}}', new Date().toLocaleDateString(props.lang).split('/')[2]).replaceAll(/20\d[0-5]/gi, new Date().toLocaleDateString(props.lang).split('/')[2]);


  const [qrPopupData, setQrPopupData] = useState(null);
  const [posCountry, setPosCountry] = useState("MY");

  const getQrPopupData = async (langCode='en-gb') => {
    let tempData = await axios.get(`${STATIC_FILE_PATH}/affiliate/install/widget/flightseo/${langCode}/file.json`).then(resp => resp.data).catch(err => {return {}});
    setQrPopupData(tempData);
  }


  const getPosCountry = async () => {
    let tempCountryData = await axios.get('https://t.airasia.com/nearestairport/airport/user').then(resp => {
      return resp.data;
    }).catch(function (error) {
      console.error("RESPONSE HEADERS | ", error.config);
      return {}
    });
    setPosCountry(_.trim(_.get(tempCountryData, 'country', "MY")));
  }

  useEffect(() => {
    getQrPopupData(props.lang);
    getPosCountry()
  }, [props.lang]);

  // const [stickyBadge, setStickyBadge] = useState("https://static.airasia.com/seo/images/others/freeseat-sticky-en-d.gif");
  const [stickyProps, setStickyProps] = useState({ dImage: "", mImage: "", url: "" });

  const getStickyProps = () => {
    let posCountryCode = _.lowerCase(posCountry)
    // return {mImage: '', dImage: '', url: ''}
    // let langCode = props.lang.split('-')[0];
    // let posLang = posCountryCode;

    switch (posCountryCode) {
      
      default: {
        return {
          eId: "",
          dImage: "",
          mImage: "",
          url: ""
        }
      }

    }
  }

  useEffect(() => {
    if (!_.includes(props.url, 'campaign')) {
      setStickyProps(getStickyProps())
    }
  }, [posCountry, props.url])

  
 
  return (
    <Theme theme={props?.isMOVE ? props?.template==='home' ? 'AIRASIA_CLASSIC' : 'AIRASIA_MOVE' : 'AIRASIA_CLASSIC'}>
      <Helmet>
        {props.meta
          ? props.meta.map((x, index) =>
              x.property === "position" ? null : (
                <meta key={"layoutHelmet" + index} {...x} content={_.replace(_.get(x, "content", ""), "{{current_year}}", new Date().toLocaleDateString(props.lang).split('/')[2])} />
              )
            )
          : null}
        <title>{titleText}</title>
        <meta name="description" content={descText} />
        <meta property="og:description" content={descText} />
        {/* <meta property="og:image" content={convertImgSrc(props.hero.image)} /> */}
        <meta property="og:title" content={titleText} />
        <meta
          property="og:url"
          content={"https://www.airasia.com/flights" + props.url}
        />
        <meta
          property="og:image"
          content="https://static.stgairasia.com/seo/static-assets/SEOFlightsImages/hero/ogimage.jpg"
        />
        <meta property="og:type" content="website" />
        <meta property="twitter:site" content="@AirAsia" />
        <meta property="twitter:card" content="summary" />
        <meta
          property="twitter:title"
          content={titleText}
        />
        <meta
          property="twitter:description"
          content={descText}
        />
        <meta
          property="twitter:image"
          content="https://static.stgairasia.com/seo/static-assets/SEOFlightsImages/hero/ogimage.jpg"
        />
        <html lang={lang} />
        <script
          async="async"
          src="https://www.googletagservices.com/tag/js/gpt.js"
        ></script>
        <link
          rel="canonical"
          href={"https://www.airasia.com/flights" + props.url}
        />

        <link
          rel="alternate"
          hreflang="en"
          href={"https://www.airasia.com/flights/" + baseURL}
        />
        <link
          rel="alternate"
          hreflang="th-TH"
          href={"https://www.airasia.com/flights/th/th/" + baseURL}
        />
        <link
          rel="alternate"
          hreflang="id-ID"
          href={"https://www.airasia.com/flights/id/id/" + baseURL}
        />
        <link
          rel="alternate"
          hreflang="zh-Hans-CN"
          href={"https://www.airasia.com/flights/zh/cn/" + baseURL}
        />
        <link
          rel="alternate"
          hreflang="zh-Hant-TW"
          href={"https://www.airasia.com/flights/zh/tw/" + baseURL}
        />
        <link
          rel="alternate"
          hreflang="zh-Hant-HK"
          href={"https://www.airasia.com/flights/zh/hk/" + baseURL}
        />
        <link
          rel="alternate"
          hreflang="ja-JP"
          href={"https://www.airasia.com/flights/ja/jp/" + baseURL}
        />
        <link
          rel="alternate"
          hreflang="ko-KR"
          href={"https://www.airasia.com/flights/ko/kr/" + baseURL}
        />
        <link
          rel="alternate"
          hreflang="x-default"
          href={"https://www.airasia.com/flights/" + baseURL}
        />
        <link rel="shortcut icon" href={props?.template==='home' ? iconaa : icon}></link>
        {BreadList.length ? (
          <script type="application/ld+json">
            {`{
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": ${JSON.stringify(BreadList)}
    }`}
          </script>
        ) : null}
        <script>{`gtmDataLayer = [{	'pageType': 'c-state',}];`}</script>
        <script>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','gtmDataLayer','GTM-WTQCST');`}
        </script>
      </Helmet>
      {/* <Nav url={props.url} /> */}
      <NavBar 
        locale={props.lang}
        currency={props?.currency || ""}
        data={uhfData}
        fireGtm={fireGtmEvent}
        device={Devices}
        template={props.template}
        isHome={props.template === 'home'}
      />

      {(!_.includes(['mobile', 'tablet'], Devices) && !_.isEmpty(_.get(stickyProps, 'dImage'))) ? <CampaignBanner isCountdown={isCountdown} countDownTexts={countDownTexts} bannerText={""}
        // link={getUrlWithLanguage(props.lang, props.url)}
        link={_.get(stickyProps, 'url' || "https://www.airasia.com/flights/")}
        liveUntil='2025-02-30 23:59:59+0800'
        eventId={_.get(stickyProps, 'eId')}
        bgImage={_.includes(['mobile', 'tablet'], Devices) ? _.get(stickyProps, 'mImage') : _.get(stickyProps, 'dImage')}
        justImage={true}
        isPopup={_.includes(['mobile', 'tablet'], Devices)}
        // bgImage={getStickyBannerImageByLang(props.lang)}
        backgroundColor={_.get(props, 'template')==='home' ? 'primary' : 'secondary'} /> : null}

      <Header {...props.hero} title={_.get(props, 'hero.title', '').replace('{{current_year}}', new Date().toLocaleDateString(props.lang).split('/')[2])} /* api={props.api} */ device={Devices} currentRoute={props.routes} lang={props.lang} 
        // bannerType2={(_.startsWith(props.routes,"SIN") || _.startsWith(props.routes,"XSP")) || (props.url.includes("/from-") && (props.url.includes("/id/id") || props.currency==='IDR'))}
        // bannerType2={!_.isEmpty(_.get(props, 'heroImages')) || _.includes(props.url, 'campaign') || !_.isEmpty(countdownTitle)}
        bannerType2={/* isBefore(new Date(), new Date(2024, 5, 2, 23, 59, 59)) || */ !_.isEmpty(_.get(props, 'heroImages.desktop')) /* || _.includes(props.url, 'campaign') */ || !_.isEmpty(countdownTitle)}
        theme={props?.isMOVE ? props?.template==='home' ? 'AIRASIA_CLASSIC' : 'AIRASIA_MOVE' : 'AIRASIA_CLASSIC'}
        url={props.url}
        heroImages={_.get(props, 'heroImages') ? _.get(props, 'heroImages', {}) : {}}
        template={props?.template}
        posCountry={posCountry}
      />
      <WebVitalRUM fireGtm={fireGtmEvent} />
      {/* {
        !_.includes(['mobile', 'tablet'], Devices) && qrPopupData?.qrPopUp?.[0]?.data?.[0]
        && 
        <QRPopUp
          environment="production"//{process.env.GATSBY_ENV === "dev" ? "DEVELOPMENT" : process.env.GATSBY_ENV === "stg" ? "STAGING" : "PRODUCTION"}
          locale={props.lang}
          sheetName="homepage"
          hidePopUpOnScroll={false}
          data={qrPopupData?.qrPopUp?.[0]?.data?.[0]}
        />
      } */}
      
      {/* {recentSearches?(
      recentSearches.length?(
        <ContinueSearchWidgetWrapper />):null):null} */}
      {/* <ContinueSearchWidgetWrapper /> */}
      <Container>
        {
          (_.includes(['mobile', 'tablet'], Devices) && !_.isEmpty(_.get(stickyProps, 'mImage')))
            ? <Link to={_.get(stickyProps, 'url' || "https://www.airasia.com/flights/campaign-discount-all-seats/")}>
              <Container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBlock: 8, marginInline: 0 }}>
                <img src={_.get(stickyProps, 'mImage')} alt='promotion' style={{ display: 'block', objectFit: 'cover', width: '100%', cursor: 'pointer' }} onClick={()=>{
                  fireGtmEvent({
                    "event": "trackEventNoEcommerce",
                    "eventDetails.category": "SEO Flights",
                    "eventDetails.action": "click",
                    "eventDetails.label": "seo|flights|mobilepromo|"+_.get(stickyProps, 'eId')
                  });
                }} />
              </Container>
            </Link>
            : null
        }
        {props.breadCrumbs.length > 0 && (
          <Bread link_list={props.breadCrumbs} current={props.routes} />
        )}


        {props.children}
      </Container>

      
      
      {/* <div style={{ transform: "scale(0.9)",textAlign: "center" }}>
        <EmojiScoringWidget lang={props.lang} device={Devices} />
      </div> */}
      {/* {StaticMobileAppCta[locale]} */}

      <AppCtaWrapper lang={props.lang} isMobile={Devices == "mobile" || Devices == "tablet"} />
      {/* {Devices == "mobile" || Devices == "tablet" ? (
        <>{AppCtaMobileWrapper[locale]}</>
      ) : (
        <>{AppCtaDesktopWrapper[locale]} </>
      )} */}

      <MobileAvaContainer>
        {/* <AVAChatbot
          adaEmbedConfig={{
            metaFields: {
              platform: "MOBILE",
              source: "SEO Flights",
            },
            parentElement: "Avaembed",
          }}
          isMobile={true}
          gtmEventData="null"
          fireGtm={() => {
            avaGtmFire()
          }}
        /> */}
      </MobileAvaContainer>
      {/* <AvaContainer>
        <AVAChatbot
          adaEmbedConfig={{
            metaFields: {
              platform: "MOBILE",
              source: "SEO Flights",
            },
            parentElement: "Avaembed",
          }}
          isMobile={false}
          gtmEventData="null"
          fireGtm={() => {
            avaGtmFire()
          }}
        />
      </AvaContainer> */}

      {/* {innerWidth <= 768 ? (
        <AVAChatbot
          adaEmbedConfig={{
            metaFields: {
              platform: "MOBILE",
              source: "SEO Flights",
            },
            parentElement: "Avaembed",
          }}
          isMobile={true}
          gtmEventData="null"
          fireGtm={() => {
            avaGtmFire()
          }}
        />
      ) : (
        <AVAChatbot
          adaEmbedConfig={{
            metaFields: {
              platform: "MOBILE",
              source: "SEO Flights",
            },
            parentElement: "Avaembed",
          }}
          isMobile={false}
          gtmEventData="null"
          fireGtm={() => {
            avaGtmFire()
          }}
        />
      )} */}
      <Footer device={Devices}
        locale={props.lang}
      />
    </Theme>
  )
}
